<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="about">
      申请向学员发送教材，申请后请等待潜店管理员审核，审核通过后，会自动给学员发送课程。
    </div>
    <div :model="dataForm" class="whiteForm">

      <van-row>
        <van-col span="6">课程类型<span class="mainColor">*</span></van-col>
        <van-col span="18" class="input">
          <input v-model="selectTypeName" placeholder="请选择课程类型" readonly @click="onShowType">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">课程<span class="mainColor">*</span></van-col>
        <van-col span="18" class="input">
          <input v-model="selectProgramName" placeholder="请选择课程" readonly @click="onShowProgram">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">姓<span class="mainColor"> *</span></van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.lastName" placeholder="请输入英文姓(拼音)">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">名<span class="mainColor"> *</span></van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.firstName" placeholder="请输入英文名(拼音)">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">生日<span class="mainColor"> *</span></van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.birthday" placeholder="请输入生日" readonly @click="showDateSelect=true">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">邮箱<span class="mainColor"> *</span></van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.email" placeholder="请输入电子邮箱">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">备注</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.remark" placeholder="请输入备注">
        </van-col>
      </van-row>
    </div>
    <div class="emptyRect" />
    <div class="downButton">
      <van-button type="info" :loading="buttonLoading" square @click="onAddProgram">提交教材申请</van-button>
    </div>

    <van-popup v-model="showType" position="bottom">
      <van-picker
        show-toolbar
        :loading="loadingList"
        title="选择课程类型"
        :columns="listType"
        :visible-item-count="6"
        @cancel="showType=false"
        @confirm="onConfirmType"
      />
    </van-popup>
    <van-popup v-model="showProgram" position="bottom">
      <van-picker
        show-toolbar
        title="选择课程"
        :columns="listProgram"
        :visible-item-count="10"
        @cancel="showProgram=false"
        @confirm="onConfirmProgram"
      />
    </van-popup>
    <van-popup v-model="showDateSelect" position="bottom">
      <van-datetime-picker
        v-model="birthday1"
        type="date"
        :max-date="maxDate"
        :min-date="minDate"
        :formatter="formatter"
        @confirm="onDateConfirm"
        @cancel="onDateCancel"
      />
    </van-popup>
  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey, formatDate, MyNotify } from '@/utils/base'
import { Button, Popup, Picker, DatetimePicker, Dialog } from 'vant'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [DatetimePicker.name]: DatetimePicker,
    [Dialog.name]: Dialog,
    TopBar
  },
  data() {
    return {
      title: '教学教材申请',
      backurl: '/textbook/applicationTextbookList',
      buttonLoading: false,
      showType: false,
      showProgram: false,
      loadingList: true,
      listAllProgram: [],
      listType: [],
      listProgram: [],
      minDate: new Date(1900, 1, 1),
      maxDate: new Date(),
      birthday1: new Date(1990, 6, 15),
      showDateSelect: false,
      selectTypeName: undefined,
      selectProgramName: undefined,
      dataForm: {
        ssiUserId: undefined,
        courseId: undefined,
        lastName: '',
        firstName: '',
        birthday: '',
        email: '',
        remark: undefined
      }
    }
  },

  created() {
    initPage()
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
  },
  methods: {
    onShowType() {
      this.showType = true
      if (this.listAllProgram.length === 0) {
        request({
          url: '/course/SSICourseList',
          method: 'post'
        }).then(Response => {
          this.loadingList = false
          if (!Response.success) {
            return
          }
          console.log(Response.data)
          this.listAllProgram = Response.data
          var newList = []
          this.listAllProgram.map((item) => {
            if (item.pid === '0') {
              newList.push({
                text: item.label,
                value: item.id
              })
            }
          })
          this.listType = newList
        })
      }
    },
    onShowProgram() {
      if (this.listProgram.length <= 0) {
        MyNotify('info', '请先选择课程类型')
        return
      }
      this.showProgram = true
    },
    onDateConfirm() {
      this.dataForm.birthday = formatDate(this.birthday1, 'yyyy-MM-dd')
      this.showDateSelect = false
    },
    onDateCancel() {
      this.showDateSelect = false
      this.dataForm.birthday = undefined
    },
    formatDate,
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      }
      return value
    },
    onConfirmType(data) {
      console.log(data)
      this.selectTypeName = data.text
      var newList = []
      this.listAllProgram.map((item) => {
        console.log(item.pid + ',' + data.value)
        if (item.pid === data.value) {
          newList.push({
            text: item.label,
            value: item.id
          })
        }
      })
      console.log(newList)
      this.listProgram = newList
      this.showType = false
    },
    onConfirmProgram(item) {
      this.selectProgramName = item.text
      this.dataForm.courseId = item.value
      this.showProgram = false
    },
    onAddProgram() {
      if (!this.dataForm.courseId || this.dataForm.courseId === 0) {
        MyNotify('info', '请选择课程')
        return
      }
      if (this.dataForm.lastName.trim().length < 1) {
        MyNotify('info', '请输入英文姓(拼音)')
        return
      }
      if (this.dataForm.firstName.trim().length < 1) {
        MyNotify('info', '请输入英文名(拼音)')
        return
      }
      if (this.dataForm.email.trim().length < 5) {
        MyNotify('info', '请输入邮箱')
        return
      }
      var myreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
      if (!myreg.test(this.dataForm.email.trim())) {
        MyNotify('info', '请输入正确的邮箱')
        return
      }
      if (!this.dataForm.birthday || this.dataForm.birthday.trim().length < 10) {
        MyNotify('info', '请输入生日')
        return
      }
      console.log('提交', this.dataForm)
      this.buttonLoading = true
      this.checkStudentCanReg((data) => {
        request({
          url: '/course/regTextBookByProUser',
          method: 'post',
          data: this.dataForm
        }).then(Response => {
          this.buttonLoading = false
          if (!Response.success) {
            return
          }
          MyNotify('success', '课程注册成功')
          this.$router.replace('/textbook/applicationTextbookList')
        })
      })
    },
    checkStudentCanReg(callback) {
      request({
        url: '/course/checkStudentCanReg',
        method: 'post',
        data: this.dataForm
      }).then(Response => {
        if (!Response.success) {
          this.buttonLoading = false
          return
        }
        if (Response.data.ssiUserId && Response.data.ssiUserId != null) {
          this.dataForm.ssiUserId = Response.data.ssiUserId
          if (callback) {
            callback(Response.data)
          }
        } else if (Response.data.ssiUserId === null && Response.data.userRegString !== null) {
          this.buttonLoading = false
          MyNotify('error', '账号不能注册:' + Response.data.userRegString)
          return
        } else if (Response.data.userRegString === null) {
          Dialog.confirm({
            title: '注册新账号',
            message: '该用户尚未注册MySSI，是否现在注册SSI账号?'
          }).then(() => {
            if (callback) {
              callback(Response.data)
            }
          }).catch(() => {
            MyNotify('info', '取消注册账号')
            this.buttonLoading = false
            return
          })
        }
      })
    }

  }
}
</script>
<style scoped>
.downButton{
    position:fixed;
    z-index: 2;
    left: 0;
    bottom: 0;
    width: 100%;
}
.downButton button{
    width: 100%;
}
.emptyRect{
    height: 3em;
}
.about{
    padding: 1em 1em 0 1em;
}
</style>
